import fpApiUtil from "./fp-api-util";

// SimulationController(@RequestMapping "/factoryplan/simulation/") 안에서 이 화면이 쓰는 엔드포인트는
// 전부 "simulation/..." 하위라 최종 URL이 factoryplan/simulation/simulation/... 으로 두 번 겹친다(old 동일).
const BASE = "factoryplan/simulation/simulation";
// 엔진 실행 여부만 컨트롤러 루트에 직접 매핑돼 있다.
const ENGINE_STATUS_URL = "factoryplan/simulation/is-engine-running";

// 저장/실행 계열은 `changes`(payload)와 `params`(planScope 등)를 **둘 다** 읽는다 —
// RequestParameter가 planScope를 `params`에서만 뽑기 때문에(RequestParameter.setLookupQueryParameter)
// postChanges 하나로는 planScope가 DEFAULT로 폴백된다. 그래서 postFields로 두 필드를 함께 보낸다.
const postParamsAndChanges = (url, params, changes) => fpApiUtil.postFields(url, { params, changes });

// 기본(최신) 메인 버전 조회. newMainVersion=true면 서버가 저장하지 않은 새 코드를 채번해서 돌려준다.
// 응답 MainVersionDto에 id가 있으면 = 이미 저장된 버전(읽기전용), 없으면 = 미저장 신규 버전(편집 가능).
const getDefaultMainVersion = (params) => fpApiUtil.postParams(`${BASE}/main-versions/default`, params);

// 메인 버전 저장. 응답 data.existVersion이 있으면 코드 중복으로 서버가 data.newVersion으로 재채번한 것.
const saveMainVersion = (params, changes) => postParamsAndChanges(`${BASE}/main-versions`, params, changes);

// 메인 버전의 실행 절차 목록(계획 단계 x 최신 플랜 버전 x 실행 이력 병합) — SimulationService.getSimulationDetails.
const getDetails = (params) => fpApiUtil.postParams(`${BASE}/details`, params);

// 플랜 버전 채번/저장. 응답 data.newVersionCd가 새 시뮬레이션 버전 코드다.
const savePlanVersion = (params, changes) => postParamsAndChanges(`${BASE}/plan-versions/save`, params, changes);

// 엔진 실행(계획). 백엔드가 FP 엔진 서버로 포워딩한다.
const executePlan = (params, changes) => postParamsAndChanges(`${BASE}/plan-versions/plan`, params, changes);

// 프로시저 실행. changes = { mainVersionCd, stepCd, stepSeq }, params.userNm이 프로시저 인자로 들어간다.
const executeProcedure = (params, changes) => postParamsAndChanges(`${BASE}/plan-versions/procedure`, params, changes);

// 시뮬레이션 실행 이력(백엔드 limit 50 고정).
const getHistories = (params) => fpApiUtil.postParams(`${BASE}/history`, params);

// 플랜 버전에 저장된 시뮬레이션 옵션 목록(SimulOptionDto: categoryCd/optnVal).
const getOptions = (params) => fpApiUtil.postParams(`${BASE}/plan-versions/options`, params);

// 시뮬레이션 옵션 저장(List<SimulOptionDto>).
const saveOptions = (params, changes) => postParamsAndChanges(`${BASE}/plan-versions/options/save`, params, changes);

// 해당 계획범위(또는 전체)에서 FP 엔진이 도는 중인지. 응답은 boolean.
const isEngineRunning = (params) => fpApiUtil.postParams(ENGINE_STATUS_URL, params);

const fpSimulationService = {
  getDefaultMainVersion,
  saveMainVersion,
  getDetails,
  savePlanVersion,
  executePlan,
  executeProcedure,
  getHistories,
  getOptions,
  saveOptions,
  isEngineRunning
};

export default fpSimulationService;
